<template lang="html">
  <div class="add-location text-center">
    <form
      @submit.prevent="submit"
      class="form-group">
      <gmap-autocomplete
        onclick="this.select()"
        ref="gmap"
        @keypress.enter.prevent="submit"
        @input="handleInput"
        @place_changed="loc => { location = loc }"
        :componentRestrictions="restrictions"
        :types="['geocode']"
        :options="{fields: ['geometry', 'name', 'formatted_address', 'vicinity']}"
        type="text"
        placeholder="Escribí aquí la nueva dirección"
        class="form-control">
      </gmap-autocomplete>
      <div :class="{'error': true, 'show': showError}">
        Ha habido un error
      </div>
      <div class="mt-3 w-100 text-center">
        <SquaredButton
          @click="$emit('close')"
          type="button"
          styleType="default"
          noUpperCase
          label="Cancelar" />
        <SquaredButton
          :isWaiting="isFetching"
          :disabled="!location"
          type="submit"
          styleType="primary"
          noUpperCase
          label="Enviar" />
      </div>
    </form>
  </div>
</template>

<script>
import store from '@/store'
import { fetchCity, fetchCityProvince } from '@/location'
import { trunkFloat } from '@/helpers'

export default {
  props: {
    then: Function
  },

  data: () => ({
    restrictions: {
      country: ['ar']
    },
    location: null,
    isFetching: false,
    showError: false
  }),

  methods: {
    fetchCity,
    fetchCityProvince,
    trunkFloat,

    submit () {
      if (!this.location) return

      this.isFetching = true

      const latLon = {
        lat: trunkFloat(this.location.geometry.location.lat()),
        lon: trunkFloat(this.location.geometry.location.lng())
      }

      this.fetchCityProvince(latLon)
        .then(loc => {
          loc.string = this.location.formatted_address

          return store.dispatch('user/storeLocation', loc)
            .then(() => {
              this.$refs.gmap.$el.value = ''
              this.$emit('close')

              const newLocations = store.state.temps.newLocations
                ? store.state.temps.newLocations.concat(this.location)
                : [this.location]
              store.dispatch('setTempLocations', newLocations)

              return store.dispatch('user/fetchUserInfo')
                .then(() => {
                  if (!!this.then) this.then()
                })
            })
            .catch(er => {
              this.showError = true
            })
            .finally(() => { this.isFetching = false })
        })
        .catch(er => { this.isFetching = false })
    },

    handleInput (e) {
      if (this.showError) this.showError = false
    }
  }
}
</script>

<style lang="scss">
  .add-location {
    & .error {
      opacity: 0;
      color: var(--danger);
      text-align: center;
      padding-top: 0.5rem;
      padding-bottom: 0;

      &.show {
        opacity: 1;
      }
    }
  }

  .pac {
    &-item {
      line-height: 35px !important;

      &-query {
        font-size: 1rem !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/AddLocation.vue